import React from "react";
import {defineBlock, smartProps, EditableImg, useEditor, ChildrenBlock} from "@smartfire/wordpress-react";
import { InnerBlocks } from '@wordpress/block-editor';
import {ReactComponent as Border} from './border.svg';
import style from "./block.module.scss";

function Block(){
    const {isEditing} = useEditor();

    return <div  className={style.block}>
        <div className={style.container}>
            <EditableImg smartProp="image" className={style.image}/>
            {isEditing ? 
            <InnerBlocks allowedBlocks={[ 'core/paragraph', 'core/bold' ]} />:
            <ChildrenBlock />}
        </div>
        <Border />
    </div>
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.any.withDefault(""),
    }, 
    setup: {
        title: "Logo + texte item",
        parent:['smartfire/logo-texte']
    }
});
